import React from "react";
import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <div className="exception-body notfound">
      <img
        src="assets/layout/images/logo-white.svg"
        alt="diamond-layout"
        className="logo"
      />

      <div className="exception-content">
        <div className="exception-title">Aradığın Yeri Bulamadın.</div>
        <div className="exception-detail">
          Endişe etme herkesin başına gelebilir.
        </div>
        <Link to="/">Geri Dön</Link>
      </div>
    </div>
  );
};
